import { PortableText } from "@portabletext/react";
import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";
import { Btn2 } from "../common/btn";
import { ElfsightWidget } from "react-elfsight-widget";

const BlogSection = ({ data, elfsight }) => {
  return (
    <div
      className="w-full px-[18px] md:px-0 flex flex-wrap items-center my-5 sm:my-10 bg-[#fafafa]"
      id={data.sectionId}
    >
      {/* Image */}
      <div className="inline-block w-full md:w-1/2 md:max-h-[510px] border border-solid border-black md:rounded-tr-md overflow-hidden md:rounded-br-md">
        {elfsight ? (
          <ElfsightWidget widgetId="0b5d5cad-1054-43e7-a436-19c0d4198c4a" />
        ) : (
          <GatsbyImage
            image={data.bgImage.asset.gatsbyImageData}
            alt={data.title}
            objectFit="cover"
            className="w-full h-full object-cover md:max-h-[510px] lg:object-contain"
          />
        )}
      </div>
      {/* Content */}
      <div className="inline-block w-full md:w-1/2 h-full px-6 pt-10 pb-[10px] md:px-[50px] md:pt-[50px] md:pb-[50px]">
        <div className="max-w-[749px] w-full space-y-6">
          <h2 className="text-2xl sm:text-4xl flex items-center justify-center w-full md:w-fit text-[#313131] md:text-black font-bold">
            {data.leftIcon && (
              <img
                src={data.leftIcon.asset.url || "/placeholder.svg"}
                alt=""
                className="w-9 sm:w-12 h-9 sm:h-12 mr-2 object-contain"
              />
            )}
            {data.title}
            {data.rightIcon && (
              <img
                src={data.rightIcon.asset.url || "/placeholder.svg"}
                alt=""
                className="w-9 sm:w-12 h-9 sm:h-12 ml-2 object-contain"
              />
            )}
          </h2>
          <div className="text-[#313131] md:text-black font-dinnext font-light text-center md:text-left text-lg leading-[25px] pb-5 md:pb-10">
            <PortableText value={data._rawDescription} />
          </div>
          {/* <div className="grid grid-cols-3 gap-4 sm:gap-7 max-w-2xl">
            {data.features.map((feature, key) => {
              if (feature.linkType === "url") {
                return (
                  <a
                    href={feature.url}
                    className="space-x-[6px] flex items-center"
                    key={key}
                  >
                    <GatsbyImage
                      image={feature.iconImage.asset.gatsbyImageData}
                      alt={feature.title}
                      objectFit="contain"
                      className="w-10 h-10 object-contain"
                    />
                    <h3 className="text-xl sm:text-2xl font-dinnext font-medium">
                      {feature.title}
                    </h3>
                  </a>
                );
              } else if (feature.linkType === "slug") {
                return (
                  <Link
                    to={feature.slug.current}
                    className="space-x-[6px] flex items-center"
                    key={key}
                  >
                    <GatsbyImage
                      image={feature.iconImage.asset.gatsbyImageData}
                      alt={feature.title}
                      objectFit="contain"
                      className="w-10 h-10 object-contain"
                    />
                    <h3 className="text-xl sm:text-2xl font-dinnext font-medium">
                      {feature.title}
                    </h3>
                  </Link>
                );
              }
            })}
          </div> */}
        </div>
        <div className="relative overflow-visible w-fit mx-auto md:mx-0">
          <Btn2 data={data.button} />
        </div>
      </div>
    </div>
  );
};

export default BlogSection;
